import React, { useEffect, useState} from "react";
import DashboardLayout from "../layout/DashboardLayout";
import API from "../api/axios";
import {
  Truck,
  Users,
  Route,
  FileText,
} from "lucide-react";
import "./Dashboard.css";

const Dashboard = () => {
  const [stats, setStats] = useState({});
  const [trips, setTrips] = useState([]);
  const [bilties, setBilties] = useState([]);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const statsRes = await API.get("/dashboard/stats");
      const tripsRes = await API.get("/trips/all");
      const biltiesRes = await API.get("/bilties/all");

      setStats(statsRes.data?.stats || {});
      setTrips(tripsRes.data?.trips || []);
      setBilties(biltiesRes.data?.bilties || []);
    } catch (err) {
      console.error("Dashboard load error:", err);
    }
  };

  const recentTrips = trips.slice(-5).reverse();
  const recentBilties = bilties.slice(-5).reverse();

  return (
    <DashboardLayout>
      <div className="dashboard">

        {/* ===== STAT CARDS ===== */}
        <div className="stats-grid">
          <div className="stat-card">
            <Truck />
            <div>
              <p>Total Trucks</p>
              <h3>{stats.totalTrucks || 0}</h3>
            </div>
          </div>

          <div className="stat-card">
            <Users />
            <div>
              <p>Total Drivers</p>
              <h3>{stats.totalDrivers || 0}</h3>
            </div>
          </div>

          <div className="stat-card">
            <Route />
            <div>
              <p>Total Trips</p>
              <h3>{stats.totalTrips || 0}</h3>
            </div>
          </div>

          <div className="stat-card">
            <FileText />
            <div>
              <p>Total Bilties</p>
              <h3>{stats.totalBilties || 0}</h3>
            </div>
          </div>
        </div>

        {/* ===== MONTHLY SUMMARY ===== */}
        <div className="summary-card">
          <h3>Monthly Summary</h3>
          <div className="summary-grid">
            <div>
              <p>Total Freight</p>
              <h4>₹ {stats.monthlyFreight || 0}</h4>
            </div>
            <div>
              <p>Total Weight</p>
              <h4>{stats.monthlyWeight || 0}</h4>
            </div>
            <div>
              <p>Average / Trip</p>
              <h4>₹ {stats.avgFreight || 0}</h4>
            </div>
          </div>
        </div>

        {/* ===== RECENT ACTIVITY ===== */}
        <div className="recent-grid">

          <div className="recent-card">
            <h3>Recent Trips</h3>
            {recentTrips.length === 0 ? (
              <p className="empty">No recent trips</p>
            ) : (
              recentTrips.map(t => (
                <div className="recent-item" key={t._id}>
                  <span>{t.origin} → {t.destination}</span>
                  <small>{t.truck}</small>
                </div>
              ))
            )}
          </div>

          <div className="recent-card">
            <h3>Recent Bilties</h3>
            {recentBilties.length === 0 ? (
              <p className="empty">No recent bilties</p>
            ) : (
              recentBilties.map(b => (
                <div className="recent-item" key={b._id}>
                  <span>Bilty #{b.biltyNumber}</span>
                  <small>₹ {b.freight}</small>
                </div>
              ))
            )}
          </div>

        </div>
      </div>
    </DashboardLayout>
  );
};

export default Dashboard;
